module.exports = __webpack_public_path__ + "static/media/13.29a5eaa7.jpg";